module.exports = Em.View.extend({
    templateName: 'recurring-invoice/edit'
})
